





















import { Vue, Component, Prop } from "vue-property-decorator";

interface Product {
  id: number;
  imgUrl: string;
  brand: string;
  name: string;
  price: number;
  originalPrice?: number;
  salePercent?: number;
  wished?: boolean;
}

@Component
export default class CartModal extends Vue {
  @Prop() product!: Product;

  currency(value: number) {
    return value.toLocaleString("ko-KR") + "원";
  }
}
